module.exports = __webpack_public_path__ + "img/1.c73d9375.png";